import fetch from "isomorphic-fetch";
import qs from "querystring";
import set from "lodash.set";

const BASE_URL = window.__APPLICATION_SERVICES__;
const LOGIN_URL = window.__LOGIN_SERVICES__;
const VS_PARAM = window.__VS__;
const INITIALIZE_URL = `${BASE_URL}api/Initialize`;
const FIELDS_URL = `${BASE_URL}api/Fields`;
const POST_WORKITEM_URL = `${BASE_URL}api/workitem`;
const CLONE_WORKITEM_URL = `${BASE_URL}api/cloneworkitem`;
const CHANGE_STATE_WORKITEM_URL = `${BASE_URL}api/changeState`;
const GET_WORKITEM_URL = `${BASE_URL}api/worklist`;
const FEES_URL = `${BASE_URL}api/Fees`;
const GET_WORKITEM_PDF_URL = `${BASE_URL}api/document`;
const USER_URL = `${BASE_URL}api/user`;
const GET_ONE_WORKITEM = `${BASE_URL}api/workitem`;
const USER_ATTRIBUTES = `${BASE_URL}api/user/attributes`;
const CHANGE_PASSWORD_URL = `${LOGIN_URL}api/LoginServices/ChangePassword`;
const CHANGE_ROLE_URL = `${BASE_URL}api/changerole`;
const GHOSTING_COMPANIES_URL = `${BASE_URL}api/ghostingCompanies`;
const RESET_ROLE_URL = `${BASE_URL}api/resetrole`;
const GET_BASIC_USAGE_REPORT = `${BASE_URL}api/basicUsage`;

export const fetchInitialize = ({ options }) => {
  return fetch(INITIALIZE_URL, options);
};

export const postFields = ({ state, body, options }) => {
  const fetchOpts = { ...options, method: "POST", body: JSON.stringify(body) };
  set(fetchOpts, "headers.Content-Type", "application/json");
  set(fetchOpts, "headers.Accept", "application/json");

  const query = qs.stringify({ state });
  return fetch(`${FIELDS_URL}?${query}`, fetchOpts);
};

export const postFields1981 = ({ state, body, options }) => {
    const fetchOpts = { ...options, method: "POST", body: JSON.stringify(body) };
    set(fetchOpts, "headers.Content-Type", "application/json");
    set(fetchOpts, "headers.Accept", "application/json");

    const query = qs.stringify({ state });
    return fetch(`${FIELDS_URL}?${query}&byPass=true`, fetchOpts);
};

export const postWorkItem = ({ state, body, options }) => {
  const query = qs.stringify({ state });
  const fetchOpts = { ...options, method: "POST", body: JSON.stringify(body) };
  set(fetchOpts, "headers.Content-Type", "application/json");

  return fetch(`${POST_WORKITEM_URL}?${query}`, fetchOpts);
};

export const putWorkItem = ({ workItemId, state, body, options }) => {
  const query = qs.stringify({ workItemId, state });
  const fetchOpts = { ...options, method: "PUT", body: JSON.stringify(body) };
  set(fetchOpts, "headers.Content-Type", "application/json");

  return fetch(`${POST_WORKITEM_URL}?${query}`, fetchOpts);
};

export const fetchWorkItems = ({
  pageSize = 25,
  page = 1,
  sortField,
  sortType,
  options
} = {}) => {
  const url = `${GET_WORKITEM_URL}?numberOfRecords=${pageSize}&pageNumber=${page}&sortField=${sortField}&sortType=${sortType}`;
  return fetch(url, options);
};

export const postFees = ({ state, body, options }) => {
  const fetchOpts = { ...options, method: "POST", body: JSON.stringify(body) };
  set(fetchOpts, "headers.Content-Type", "application/json");

  const query = qs.stringify({ state });
  return fetch(`${FEES_URL}?${query}`, fetchOpts);
};

export const fetchWorkItemPDF = ({ workItemId, type, options }) => {
  const query = qs.stringify({ workItemId, type });
  return fetch(`${GET_WORKITEM_PDF_URL}?${query}`, options);
};

export const logoutUser = ({ options }) => {
  return fetch(`${USER_URL}/logout`, options);
};

export const fetchOneWorkItem = ({ id, status, options }) =>
  fetch(`${GET_ONE_WORKITEM}?workItemId=${id}&status=${status}`, options);

export const fetchUserAttributes = ({ options }) => {
  return fetch(USER_ATTRIBUTES, options);
};

export const fetchChangePassword = ({ body, options }) => {
  body.vs = VS_PARAM;
  const fetchOpts = { ...options, method: "POST", body: JSON.stringify(body) };
  set(fetchOpts, "headers.Content-Type", "application/json");
  set(fetchOpts, "headers.Accept", "application/json");
  body.vs = "";

  return fetch(CHANGE_PASSWORD_URL, fetchOpts);
};

export const fetchChangeRole = ({ companyId, options }) => {
  return fetch(`${CHANGE_ROLE_URL}?companyId=${companyId}`, options);
};

export const fetchGhostingCompanies = ({ options }) => {
  return fetch(GHOSTING_COMPANIES_URL, options);
};

export const fetchResetRole = ({ options }) => {
  return fetch(RESET_ROLE_URL, options);
};

export const fetchBasicUsageReport = ({ body, options }) => {
  const url = `${GET_BASIC_USAGE_REPORT}?dateFrom=${body.start_date}&dateTo=${body.end_date}&numOfRecords=${body.records}&pageSize=${body.page}&states=${body.selectedStates.join("&states=")}&type=${body.type}`;
  return fetch(url, options);
};

export const cloneWorkitem = ({ workitemId, externalId,  options }) => {
  const fetchOpts = { ...options, method: "POST" };
  set(fetchOpts, "headers.Content-Type", "application/json");

  const query = externalId !== null ? qs.stringify({ workitemId, externalId }) : qs.stringify({ workitemId });
  return fetch(`${CLONE_WORKITEM_URL}?${query}`, fetchOpts);
};

export const changeStateClonedWorkitem = ({ state, workitemId,  options }) => {
  const fetchOpts = { ...options, method: "PUT" };
  set(fetchOpts, "headers.Content-Type", "application/json");

  const query = qs.stringify({ workitemId, state });
  return fetch(`${CHANGE_STATE_WORKITEM_URL}?${query}`, fetchOpts);
};